import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { getEmployeeCollection, EmployeeCollectionModel } from "@tCentro/Services/CENAdminEmployeeService";

export interface GetEmployeeCollectionParameter extends HasOnSuccess<EmployeeCollectionModel>, HasOnError<string> {}

type HandlerType = ApiHandler<GetEmployeeCollectionParameter, { apiResult: EmployeeCollectionModel }>;
export interface GetEmployeeCollectionParameter extends HasOnSuccess<EmployeeCollectionModel>, HasOnError<string> {
    page?: number;
    pageSize?: number;
    query?: string;
}

export const GetEmployeeCollection: HandlerType = async props => {
    try {
        const result = await getEmployeeCollection(props.parameter.page, props.parameter.pageSize, props.parameter.query);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to load employees");
        }
    }
};

export const chain = [GetEmployeeCollection];
const getEmployeeCollectionData = createHandlerChainRunner(chain, "getEmployeeCollectionData");
export default getEmployeeCollectionData;
